/* @ngInject */
const invoicingRun = (
  $transitions,
  routes
) => {
  $transitions.onSuccess({
    to: routes.invoicing.index.path,
  }, (trans) => {

  })
}

export default invoicingRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/invoicing/invoicing.run.js